var _path, _g, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBellIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 26,
    viewBox: "0 0 23 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Mask Group"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_157_3099",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 23,
    height: 21
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.5 0.164062H22.0797V20.4034H0.5V0.164062Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_157_3099)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Exclude",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.2882 1.91406C7.21068 1.91406 4.36868 5.1084 4.36868 7.9749C4.36868 10.4004 3.69552 11.5216 3.10052 12.5109C2.62335 13.3054 2.24652 13.9331 2.24652 15.2969C2.44135 17.4972 3.89385 18.6534 11.2882 18.6534C18.6417 18.6534 20.1397 17.4459 20.3333 15.2211C20.3298 13.9331 19.953 13.3054 19.4758 12.5109C18.8808 11.5216 18.2077 10.4004 18.2077 7.9749C18.2077 5.1084 15.3657 1.91406 11.2882 1.91406ZM11.2882 20.4034C5.83285 20.4034 0.902516 20.0184 0.500016 15.3716C0.496516 13.4489 1.08335 12.4712 1.60135 11.6102C2.12518 10.7376 2.61868 9.91506 2.61868 7.9749C2.61868 4.20306 6.10235 0.164062 11.2882 0.164062C16.474 0.164062 19.9577 4.20306 19.9577 7.9749C19.9577 9.91506 20.4512 10.7376 20.975 11.6102C21.493 12.4712 22.0798 13.4489 22.0798 15.2969C21.6727 20.0184 16.7435 20.4034 11.2882 20.4034Z",
    fill: "#212121"
  })))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.2351 25.2478H11.2328C9.92493 25.2466 8.6871 24.6703 7.74793 23.6238C7.42477 23.2656 7.45393 22.7114 7.81327 22.3894C8.1726 22.0651 8.7256 22.0943 9.04877 22.4548C9.6531 23.1279 10.4289 23.4978 11.2339 23.4978H11.2351C12.0436 23.4978 12.8229 23.1279 13.4284 22.4536C13.7528 22.0954 14.3058 22.0663 14.6639 22.3894C15.0233 22.7126 15.0524 23.2668 14.7293 23.6249C13.7866 24.6714 12.5464 25.2478 11.2351 25.2478Z",
    fill: "#212121"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBellIcon);
export default __webpack_public_path__ + "static/media/bellIcon.e3328b5e44e7274f67cc7cb18da27e23.svg";
export { ForwardRef as ReactComponent };